module.exports = __webpack_public_path__ + "static/media/rechazado-marker.0fc68638.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/img/rechazado-marker.svg
// module id = 875
// module chunks = 0